import type { RootState } from 'store';

export const selectActiveMenu = (state: RootState) => state.settings.activeMenu;
export const selectPageLoading = (state: RootState) => state.settings.pageLoading;
export const selectBreadCrumbParams = (state: RootState) => state.settings.breadcrumbParams;
export const selectSuccessMessage = (state: RootState) => state.settings.successMessage;
export const selectErrorMessage = (state: RootState) => state.settings.errorMessage;
export const selectRouteLeavingConfigs = (state: RootState) => state.settings.routeLeavingConfigs;
export const selectGenerateReportEndedStatus = (state: RootState) => state.settings.generateReportEndedStatus;
export const selectCallEndedStatus = (state: RootState) => state.settings.endedStatus;
export const selectNoAccess = (state: RootState) => state.settings.noAccess;
